import { UisSecurityLevelModelDto } from '@treasury/api/bo';
import { DomainEntity } from '../../../../shared';

export class UisSecurityLevel extends DomainEntity<UisSecurityLevelModelDto> {
    public static from(dto: UisSecurityLevelModelDto): UisSecurityLevel {
        return new UisSecurityLevel(dto);
    }

    public createDefault(): this {
        throw new Error('createDefault not implemented');
    }

    public get id() {
        return this.dto.id ?? 0;
    }

    public get description() {
        return this.dto.description ?? '';
    }

    public get value() {
        return this.dto.value ?? '';
    }
}
